import axios from 'axios';
import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import CommonService from '../../../services/commonService';
import {
  MY_ACCOUNT_API_CALL_BEGIN,
  MY_ACCOUNT_API_CALL_SUCCESS,
  MY_ACCOUNT_API_CALL_FAILURE,
  MY_ACCOUNT_API_CALL_DISMISS_ERROR,
} from './constants';

export function apiCall(args = {}) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: MY_ACCOUNT_API_CALL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      let doRequest;
      if (args.method === 'PUT') {
        doRequest = axios.put(args.url, args.data, {
          headers: CommonService.getHeaders(),
        });
      } else if (args.method === 'POST') {
        doRequest = axios.post(args.url, args.data, {
          headers: CommonService.getHeaders(),
        });
      } else if (args.method === 'DELETE') {
        doRequest = axios.delete(args.url, {
          headers: CommonService.getHeaders(),
        });
      } else {
        doRequest = axios.get(args.url, {
          headers: CommonService.getHeaders(),
        });
        // console.log('Headers', CommonService.getAtHeaders());
      }
      doRequest.then(
        res => {
          dispatch({
            type: MY_ACCOUNT_API_CALL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: MY_ACCOUNT_API_CALL_FAILURE,
            data: { error: err },
          });
          if (err.response && err.response.status === 401) {
            CommonService.logout();
            window.location.href = '/';
          }
          reject(err.response);
        },
      );
    });

    return promise;
  };
}

export function dismissApiCallError() {
  return {
    type: MY_ACCOUNT_API_CALL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MY_ACCOUNT_API_CALL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        apiCallPending: true,
        apiCallError: null,
      };

    case MY_ACCOUNT_API_CALL_SUCCESS:
      // The request is success
      return {
        ...state,
        apiCallPending: false,
        apiCallError: null,
      };

    case MY_ACCOUNT_API_CALL_FAILURE:
      // The request is failed
      return {
        ...state,
        apiCallPending: false,
        apiCallError: action.data.error,
      };

    case MY_ACCOUNT_API_CALL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        apiCallError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/my-account/redux/apiCall.js